import { render } from "./instructor-profile.vue?vue&type=template&id=ab4513da"
import script from "./instructor-profile.vue?vue&type=script&lang=js"
export * from "./instructor-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__